import React from 'react';
import { ActionBar } from 'components/common/general/CollectionManagementPanel/ActionBar';
import { StatusFilterDropdown } from './StatusFilterDropdown';
import { ProductLineFilterDropdown } from './ProductLineFilterDropdown';
import { StateFilterDropdown } from './StateFilterDropdown';
import { EffectiveYearFilterDropdown } from './EffectiveYearFilterDropdown';

export const FiltersActionBar: React.FC = () => {
  return (
    <ActionBar>
      <StatusFilterDropdown />
      <ProductLineFilterDropdown />
      <EffectiveYearFilterDropdown />
      <StateFilterDropdown />
    </ActionBar>
  );
};
